// extracted by mini-css-extract-plugin
export var displayNone = "_u2-6";
export var imgContainer = "_u2-2";
export var overflowHidden = "_u2-3";
export var productInfoCardButtonContainer = "_u2-5";
export var productTitleText = "_u2-4";
export var rightArrow = "_u2-1";
export var rightArrowContainer = "_u2-0";